import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomAddTag = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="m12.41 2.58 9 9c.36.36.59.87.59 1.42s-.22 1.05-.59 1.41l-7 7c-.36.37-.86.59-1.41.59s-1.05-.22-1.41-.58l-.362-.362a6.002 6.002 0 0 1-8.286-8.286l-.352-.352C2.22 12.05 2 11.55 2 11V4c0-1.1.9-2 2-2h7c.55 0 1.05.22 1.41.58m.298 17.138a6.002 6.002 0 0 0-8.421-8.43L4 11V4h7v-.01l9 9-7 7.02zM8 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m.6 10.1h1.8c.33 0 .6-.27.6-.6s-.27-.6-.6-.6H8.6v-1.8c0-.33-.27-.6-.6-.6s-.6.27-.6.6v1.8H5.6c-.33 0-.6.27-.6.6s.27.6.6.6h1.8v1.8c0 .33.27.6.6.6s.6-.27.6-.6z"
  />,
  'CustomAddTag',
);

export default CustomAddTag;
